import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const VENDOR_CARDS_VIEW_ATTRIBUTE_OPTIONS: CardsViewAttributeOption<Vendor>[] = [
    { name: "outstanding_commitments", label: "Current Balance" },
    { name: "current_purchase_order_count", label: "Open POs" },
    { name: "payment_terms", label: "Terms" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "labels", label: "Labels" },
]

export const VENDOR_CARDS_VIEW_SORT_OPTIONS: CardsViewSortOption<Vendor>[] = [
    { name: "name", label: "Vendor" },
    { name: "account_id", label: "Account ID" },
    { name: "billing_address_formatted", label: "Billing Address" },
    { name: "payment_terms", label: "Terms" },
    { name: "default_billing_vendor_name", label: "Bills Via" },
    { name: "current_purchase_order_count", label: "Current POs" },
    { name: "outstanding_commitments", label: "Commitments" },
    { name: "outstanding_payables", label: "Payables" },
    { name: "last_modified_at", label: "Last Modified" },
]
